import React from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, Package, ShoppingBag, Users, Mail, LogOut, Home, ImageIcon } from "lucide-react";
import { useAuth } from "@/lib/auth";
import Logo from "@/components/Logo";

const items = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/orders", label: "Orders", icon: ShoppingBag },
  { to: "/admin/products", label: "Products", icon: Package },
  { to: "/admin/banners", label: "Banners", icon: ImageIcon },
  { to: "/admin/customers", label: "Customers", icon: Users },
  { to: "/admin/email-logs", label: "Email logs", icon: Mail },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="min-h-screen grid lg:grid-cols-[240px_1fr] bg-slate-50">
      <aside className="bg-slate-900 text-slate-200 lg:min-h-screen">
        <div className="p-4 flex items-center gap-2 border-b border-slate-800">
          <Logo size="sm" theme="dark" showWord={false} />
          <div>
            <div className="font-display font-bold text-white">Noyaa</div>
            <div className="text-xs text-slate-400">Admin panel</div>
          </div>
        </div>
        <nav className="p-3 space-y-1 text-sm">
          {items.map((i) => (
            <NavLink key={i.to} to={i.to} end={i.end}
              className={({isActive}) => `flex items-center gap-2 px-3 py-2 rounded-lg ${isActive ? "bg-emerald-600 text-white" : "hover:bg-slate-800"}`}
              data-testid={`admin-nav-${i.label.toLowerCase().replace(" ","-")}`}>
              <i.icon className="h-4 w-4"/> {i.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 mt-4 border-t border-slate-800 space-y-1 text-sm">
          <NavLink to="/" className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-slate-800"><Home className="h-4 w-4"/> Back to store</NavLink>
          <button onClick={() => { logout(); nav("/login"); }} className="w-full text-left flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-slate-800" data-testid="admin-logout"><LogOut className="h-4 w-4"/> Sign out</button>
        </div>
      </aside>
      <main className="p-6 lg:p-8">
        <div className="mb-6 flex justify-between items-center">
          <div className="text-sm text-slate-500">Signed in as <strong className="text-slate-900">{user?.email}</strong></div>
        </div>
        <Outlet/>
      </main>
    </div>
  );
}
